'use client';

import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { setAlgoliaAnalyticsContext } from '@/joystagram-components/commons/algoliaAnalyticsContext';

/**
 * Publishes the CMS route kind a catch-all path resolved to, so the Algolia
 * search client can tell a PDP from a category page (CON-8651).
 *
 * The path alone cannot: `/sofas/hughes-sofa/` and `/modern/desks/` are served
 * by the same CMS route, and only getCatchAllRouteKind — which needs the route
 * metadata the server already fetched — separates them.
 *
 * `path` travels with the kind because on a soft navigation this write and the
 * `usePathname()` write in AlgoliaAnalyticsContextSync are independent; pairing
 * them lets the tag builder discard a kind that belongs to the previous page.
 */
const AlgoliaRouteKindSync = ({ routeKind, path }) => {
  useEffect(() => {
    setAlgoliaAnalyticsContext({ routeKind, routeKindPath: path });
  }, [routeKind, path]);

  return null;
};

AlgoliaRouteKindSync.propTypes = {
  routeKind: PropTypes.string,
  path: PropTypes.string,
};

export default AlgoliaRouteKindSync;
